import React, { type ReactElement } from 'react';

/**
 * Fallback content if the requested report is unexpected
 */
export default function UnSupportedReport(): ReactElement {
  return (
    <div className="alert-warning card">
      <h5 className="card-header">Report not supported</h5>
      <div className="card-body">
        <p>Not sure how you got here but this report is not supported by cluster reporting</p>
        <p>Please contact NZCER if you think this is a mistake</p>
      </div>
    </div>
  );
}
